import { render, staticRenderFns } from "./UndefinedDepositor.vue?vue&type=template&id=86c3585e&"
import script from "./UndefinedDepositor.vue?vue&type=script&lang=ts&"
export * from "./UndefinedDepositor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports